import React from 'react'
import PropTypes from 'prop-types'
import Panel from 'common/components/Panel'
import Resource from 'common/components/Resource'
import CommunitiesForm from '../communitiesForm'
import { updateCommunity } from '../actions'

const handleSubmit = id => async (values, form) => {
  const { setSubmitting, setStatus, setErrors } = form
  const { name, city, multilingual } = values
  try {
    await updateCommunity(id, {
      name,
      city_id: city,
      multilingual
    })
    setSubmitting(false)
    setStatus({ success: true })
    window.location.reload();
  } catch (e) {
    setStatus({ success: false })
    setErrors({ http: e.message })
    setSubmitting(false)
  }
}

const EditCommunity = ({ match }) => (
  <div>
    <Panel title='Edit Neighborhood'>
      <Resource
        name='communities'
        resourceId={match.params.id}
        render={community => (
          <CommunitiesForm
            handleSubmit={handleSubmit(match.params.id)}
            initialValues={{
              name: community.name || '',
              city: community.city_id || 0,
              multilingual: community.multilingual || false
            }}
            isEdit
            disableLangPref={!!community.multilingual}
          />
        )}
      />
    </Panel>
  </div>
)

EditCommunity.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
}

export default EditCommunity
